<template>
    <b-modal id="vacation_period"
             v-bind:no-close-on-backdrop=true
             v-model="show"
             size="lg"
             title="Редагувати період відпустки"
    >
        <div>
            <date-picker value-type="format" v-model="form.time_range" :lang="d_lang" range :shortcuts="shortcuts"
                         confirm :first-day-of-week="1"></date-picker>
            <b-form-valid-feedback :state="can_format">
                терміном на {{ diff_days }} дні(в) в період з {{ form.time_range[0] | formatDate }} по
                {{ form.time_range[1] | formatDate }}
            </b-form-valid-feedback>
        </div>
        
        <template slot="modal-footer" slot-scope="{ ok, cancel }">
            
            <b-spinner variant="success" v-if="show_action"></b-spinner>
            <b-button size="xl" variant="outline-primary" @click.prevent="save()"
                      class="btn btn-lg  waves-effect waves-themed mr-3">
                <i class="fal fa-check mr-1"></i>
                Зберегти
            </b-button>
        </template>
    </b-modal>

</template>

<script>

import DatePicker from 'vue2-datepicker';

export default {
    name: "period_block",
    components: {
        DatePicker
    },
    props: {},
    
    data() {
        return {
            show: false,
            show_action: false,
            form: {
                time_range: [],
                
            },
            doc_id: 0,
            'vacation': null,
            time_range: [],
            time_range_start: [
                new Date(), new Date()
            ],
            shortcuts: [
                {
                    onClick: () => {
                        this.time_range_start
                    }
                }
            ],
        }
        
    },
    created() {
        EventBus.$on('edit_vacation_period', e => {
            if (e !== undefined) {
                this.doc_id = e.doc_id;
                if (e.hasOwnProperty('real_from')) {
                    this.form.time_range = [e.real_from, e.real_to];
                    this.time_range = [e.real_from, e.real_to];
                }
            }
            this.show = true;
        });
    },
    
    methods: {
        
        save() {
            this.show_action = true;
            this.try_save();
            
        },
        
        
        async try_save() {
            await api.patch('/memorandums/' + this.doc_id + '/vacation/period', {
                'doc_id'    : this.doc_id,
                'from'      : this.form.time_range[0],
                'to'        : this.form.time_range[1],
                'from_old'  : this.time_range[0],
                'to_old'    : this.time_range[1]
                
            }).then(({data}) => {
                if(data.status == 'operation_success') {
                    EventBus.$emit("reload_mem", {"mem_id": this.doc_id});
                    
                    this.show_action = false
                    this.show = false;
                    this.time_range = this.form.time_range;
                    
                    
                }
            }).catch(err => {
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
            });
        }
    },
    
    computed: {
        d_lang() {
            return this.get_datepickLang();
        },
        
        can_format() {
            return this.form.time_range.length > 0 && this.form.time_range[0].length > 0 && this.form.time_range[1].length > 0;
        },
        
        diff_days() {
            if (this.can_format) {
                const start = new moment(this.form.time_range[0]);
                const end = new moment(this.form.time_range[1]);
                return moment.duration(end.diff(start)).asDays() + 1;
                
            }
        },
        
        
    },
}
</script>

<style scoped>

</style>
